exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1F-fD{background-color:#fff;-ms-flex-item-align:center;align-self:center;position:relative;-webkit-box-shadow:0 0 30px rgba(0,0,0,.15);box-shadow:0 0 30px rgba(0,0,0,.15);border-radius:3px;max-width:320px;overflow-y:auto;max-height:100vh;margin:0 auto}._1xv5j{padding:20px 15px}._-5-3g{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}", ""]);

// exports
exports.locals = {
	"root": "_1F-fD",
	"container": "_1xv5j",
	"closeBtnIcon": "_-5-3g"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/DialogContainer/DialogContainer.css
// module id = 1716
// module chunks = 15 20 21 23 32 33 38